"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _upsellActions = require("../../store/upsell/upsellActions");
var useComparisonNavigation = function useComparisonNavigation() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var onBack = function onBack() {
    dispatch((0, _upsellActions.goBackToRecommendation)());
  };
  return {
    onBack: onBack
  };
};
var _default = useComparisonNavigation;
exports.default = _default;